import { TemplateResult } from 'lit-html';
const KOMPIS_ELEMENT_REGEXP = /(kompis|skapa)-[a-z0-9-]+/gm;
export default class KompisElementInternalRegistryRewriter {
    /**
     * Constructor.
     *
     * @param element Element.
     */
    constructor(element) {
        this.element = element;
    }
    /**
     * Rewrites Kompis tag names to internal tag name in KompisElementRegistry (e.g. "kompis-button" becomes "kompis-button-az34o4Az").
     *
     * @param templateResult Template result.
     * @returns Template result.
     */
    rewriteTemplateResult(templateResult) {
        const newStrings = [];
        for (let i = 0, max = templateResult.strings.length; i < max; i++) {
            newStrings[i] = this.parseHTML(templateResult.strings[i]);
        }
        // eslint-disable-next-line dot-notation
        newStrings['raw'] = newStrings.slice();
        templateResult.strings = newStrings;
        templateResult.values = (this.parseTemplateResultValues(templateResult.values));
        return templateResult;
    }
    /**
     * Parses template result values.
     *
     * @param values ...
     * @returns New HTML.
     */
    parseTemplateResultValues(values) {
        const newValues = [];
        let hasChanged = false;
        for (let i = 0, max = values.length; i < max; i++) {
            if (values[i] instanceof TemplateResult) {
                newValues[i] = this.rewriteTemplateResult(values[i]);
                hasChanged = true;
            }
            else if (Array.isArray(values[i])) {
                newValues[i] = this.parseTemplateResultValues(values[i]);
                hasChanged = true;
            }
            else if (typeof values[i] === 'string') {
                newValues[i] = this.parseHTML(values[i]);
                if (newValues[i] !== values[i]) {
                    hasChanged = true;
                }
            }
            else {
                newValues[i] = values[i];
            }
        }
        // "hasChanged" makes sure that the reference to the Array is the same for props if it has not been modified (e.g. element.stores === Stores)
        return hasChanged ? newValues : values;
    }
    /**
     * Parses HTML.
     *
     * @param html HTML.
     * @returns New HTML.
     */
    parseHTML(html) {
        const regexp = new RegExp(KOMPIS_ELEMENT_REGEXP, 'gm');
        let lastIndex = 0;
        let newHTML = '';
        let match;
        while ((match = regexp.exec(html)) !== null) {
            const internalName = this.element.customElements.getInternalName(match[0]);
            const isTag = html[regexp.lastIndex - match[0].length - 1] === '<';
            if (internalName) {
                newHTML += html.substring(lastIndex, regexp.lastIndex - match[0].length) + internalName;
                if (isTag) {
                    newHTML += ` data-element-name="${match[0]}" `;
                }
            }
            else {
                if (isTag) {
                    console.warn(`Warning! The element "${match[0]}" could not be found in the internal registry when rendering "${this.element.tagName.toLowerCase()}". Did you forget to register it?`);
                }
                newHTML += html.substring(lastIndex, regexp.lastIndex);
            }
            lastIndex = regexp.lastIndex;
        }
        newHTML += html.substring(lastIndex);
        return newHTML;
    }
}
//# sourceMappingURL=KompisElementInternalRegistryRewriter.js.map